export default __webpack_public_path__ + "static/media/risk@3x.0492e0b9.png";